export default "__VITE_ASSET__HgfzvHEd__"